import { User } from '@auth0/auth0-react';
import classNames from 'classnames';

interface Props {
  user: Pick<User, 'username' | 'picture'>;
  showUserName?: boolean;
  size?: 'lg' | 'xl' | 'normal';
}

export default function UserBadge({
  user,
  showUserName,
  size = 'normal',
}: Props) {
  return (
    <div className="flex shrink-0 items-center">
      <img
        src={user.picture}
        alt={user.username}
        title={user.username}
        className={classNames('flex-shrink-0 rounded-full', {
          'h-5 w-5': size === 'normal',
          'h-6 w-6': size === 'lg',
          'h-8 w-8': size === 'xl',
        })}
      />
      {showUserName && (
        <span
          className="ml-3 block truncate text-sm font-normal"
          title={user.username}
        >
          {user.username}
        </span>
      )}
    </div>
  );
}
